import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Dispatch, SetStateAction } from "react";
import { AreaOfInterestPreview } from "../../../../../../../../types/areaOfInterest";

const FilePreview = ({
  isOpen,
  setIsOpen,
  areaOfInterests,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  areaOfInterests: AreaOfInterestPreview | null;
}) => {
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Stack>
      <Dialog open={isOpen} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: 400,
          }}
        >
          <Typography fontWeight={400} variant="h5">
            Attribute Preview
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead>
                <TableRow>
                  {Object.keys(
                    areaOfInterests?.geojson.features[0]?.properties ?? {}
                  ).map((attribute, index) => (
                    <TableCell
                      sx={{ border: "1px solid #e0e0e0", bgcolor: "#F4F4F4" }}
                      scope="row"
                    >
                      {attribute}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {areaOfInterests?.geojson.features.map((row, index) => (
                  <TableRow
                    key={row.id}
                    sx={{
                      border: "1px solid #e0e0e0",
                      bgcolor: index % 2 ? "#E9E7E4" : "#FAFAF9",
                    }}
                  >
                    {Object.values(row?.properties ?? {}).map((attribute) => (
                      <TableCell sx={{ border: "1px solid #e0e0e0" }}>
                        {attribute}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    </Stack>
  );
};

export default FilePreview;
